// import logo from './logo.svg';
import { useState, useEffect, useRef } from 'react';
import './assets/scss/App.scss';
import ScrollToTop from './components/ScrollToTop';
import About from './pages/About';
import Experience from './pages/Experience';
import Project from './pages/Project';



import Intro from './components/Intro';
import Socialmedia from './components/Socialmedia';
import Footer from './components/footer';
import ProjectArchiveLink from './components/ProjectArchiveLink';
import Resume from './components/Resume';



function App() {
  const about = useRef(null);
  const experience = useRef(null);
  const project = useRef(null);
  // const portfolio = useRef(null)
  
  const scrollToSection = (elementRef) => {
    window.scrollTo({
      top: elementRef.current.offsetTop,
      behavior: 'smooth'
    })
  }
  const [position, setPosition] = useState({ x: 0, y: 0 });
  // const myRef = useRef(null);
  useEffect(() => {
    const handleMouseMove = (event) => {
      setPosition({
        x: event.clientX,
        y: event.clientY,
      });
    };
    // Add event listener
    window.addEventListener("mousemove", handleMouseMove);
    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  // Active Navigation 
  // const targetRef = useRef(null);
  const [activeSection, setActiveSection] = useState(true);
  const observer = useRef(false);

  useEffect(() => {
    const sections = document.querySelectorAll('.section');
    observer.current = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setActiveSection(entry.target.id);
          // console.log('Element is in view!');
        } else {
          // console.log('Element is not in view!');

          if (activeSection === entry.target.id) {
            setActiveSection(null);
          }
        }
      });
    }, 
    {  root: null, // Use the viewport as the root
        rootMargin: '0px',
        threshold: 0.1, 
      }); // Threshold determines when a section is considered in view


    sections.forEach(section => {
      observer.current.observe(section);
    });

    return () => {
      observer.current.disconnect();
    };
  }, []);

  // flex-shrink-0 flex mr-4 items-center justify-center w-20 h-20 rounded-full 
  return (
    <section className="App bg-slate-900 leading-relaxed text-slate-400 font-inter font-feature-default  antialiased selection:bg-violet-100 selection:text-teal-900 font-normal">
     
      <section className='container mx-auto'>
        <section className='lg:flex lg:justify-between lg:gap-4'>
        {/* lg:py-24 */}
          <aside id="default-sidebar" className="lg:pr-20 lg:sticky lg:flex lg:max-h-screen lg:w-[32%] lg:flex-col lg:justify-between " aria-label="Sidebar">
            <div className="lg:flex lg:justify-between lg:gap-4 fixed ">
            {/* lg:py-24 */}
              <header className='header h-screen lg:sticky lg:flex lg:max-h-screen lg:flex-col lg:justify-between lg:pt-20 '>
                <div>
                  <Intro />
                  {/* <p>X: {position.x}, Y: {position.y}</p> */}
                  <ul className="jump-nav" id='nav'>
                    <li onClick={() => scrollToSection(about)} className={`link gap-4 ${activeSection === 'section1' ? 'active' : ''}`}>
                      <span className='nav-indicator'></span>
                      <span className='nav-text'>About</span>
                    </li>
                    <li onClick={() => scrollToSection(experience)} className={`link gap-4 ${activeSection === 'section2' ? 'active' : ''}`}>
                      <span className='nav-indicator'></span>
                      <span className='nav-text'>Experience</span></li>
                
                   
                    <li onClick={() => scrollToSection(project)} className={`link gap-4 ${activeSection === 'section3' ? 'active' : ''}`}>
                      <span className='nav-indicator'></span>
                      <span className='nav-text'>Projects</span></li>

                  </ul>
                 
                </div>
                <Socialmedia />
              </header>

            </div>
          </aside >

          <section className='p-4 lg:pt-20 content-wrapper lg:w-[68%]'>
          {/* { activeSection ? "about section active " : "about section "} */}
            {/* <section className={ "about section"} id="section1"></section> */}
            <section ref={about} className={activeSection ? "about section active " : "about section "} id="section1"><About /></section>
            <section ref={experience} className="experience section" id="section2"><Experience /></section> 
            <section> <div className='md-12'><Resume/></div></section>
            <section ref={project} className="project section" id="section3"><Project /></section>
            <ProjectArchiveLink/>

            <Footer/>

          </section>
        </section>
      </section>
      <ScrollToTop />

      <div style={{ top: `${position.y}px`, left: `${position.x}px`, background: `radial-gradient(${600}px at ${position.y}px ${position.x}px rgba(29, 78, 216, 0.15))`, }} className='mouseMove pointer-events-none fixed inset-0 z-30 transition duration-300 lg:absolute'></div>
    </section>

  );
}

export default App;
